import { get_paywalls_state_config } from '../base';

export default get_paywalls_state_config({
    url: '/payment_count',
    title: 'Payment Count',
    template: require('./view.html'),
    service_method_name: 'payment_count_by_mission_range',
    is_missions_required: true,
});
